import { createSlice } from '@reduxjs/toolkit';

const loadingSlice = createSlice({
  name: 'loading',
  initialState: {
    isLoading: false,
    reloadRefreshData: false
  },
  reducers: {
    setLoading: (state, action) => {
      state.isLoading = action.payload;
    },
    setReloadRefreshData: (state, action) => {
      state.isLoading = action.payload;
    },
  },
});
export const { setLoading, setReloadRefreshData } = loadingSlice.actions;
export default loadingSlice.reducer;
